import Home from './views/Home.vue'

let routes = [
    {
        path: '/login',
        component: () => import('@/views/Login.vue'),
        name: '',
        hidden: true
    },
    {
        path: '/404',
        component: () => import('@/views/404.vue'),
        name: '',
        hidden: true
    },
    {
        path: '/',
        component: Home,
        name: '',
        iconCls: 'fa fa-rmb',
        iconNormal:'/static/img/tab/tab_home1.png',
        iconSel:'/static/img/tab/tab_home1_sel.png',
        leaf: true,//只有一个节点
        children: [
            { path: '/index', component: () => import('@/views/index/index.vue'), name: '电费管理' }
        ],
        redirect: { path: '/index' }
    },
    // {
    //     path: '/',
    //     component: Home,
    //     name: '账号权限',
    //     iconCls: 'fa fa-address-card',
    //     leaf: true,//只有一个节点
    //     children: [
    //         { path: '/activityManage/index', component: () => import('@/views/activityManage/index.vue'), name: '账号权限' }
    //     ],
    // },
    {
        path: '/',
        component: Home,
        name: '店铺管理',
        iconCls: 'fa fa-cog',
        iconNormal:'/static/img/tab/tab_home2.png',
        iconSel:'/static/img/tab/tab_home2_sel.png',

        leaf: true,//只有一个节点
        children: [
            { path: '/data/shopManage', component: () => import('@/views/shopManage/index.vue'), name: '店铺管理' },
            { path: '/data/shopCreate', component: () => import('@/views/shopManage/shopCreate.vue'), name: '店铺管理' }
        
            
        ]
    },
    {
        path: '/',
        component: Home,
        name: '账号权限',
        iconCls: 'fa fa-user-o',
        iconNormal:'/static/img/tab/tab_home3.png',
        iconSel:'/static/img/tab/tab_home3_sel.png',
        leaf: true,//只有一个节点
        children: [
            { path: '/data/accountManage', component: () => import('@/views/accountManage/index.vue'), name: '账号权限' },
            { path: '/data/accountCreate', component: () => import('@/views/accountManage/accountCreate.vue'), name: '账号权限', hidden: true },
            { path: '/data/accountEdit', component: () => import('@/views/accountManage/accountEdit.vue'), name: '账号权限', hidden: true },
            // { path: '/data/yimaiCrmCard', component: () => import('@/views/yimaiCrmCard/index.vue'), name: '红木名片智能CRM' }
        ]
    },
    {
        path: '/',
        component: Home,
        name: '下载二维码',
        iconCls: 'fa fa-qrcode',
        iconNormal:'/static/img/tab/tab_home4.png',
        iconSel:'/static/img/tab/tab_home4_sel.png',
        leaf: true,//只有一个节点
        children: [
            { path: '/data/qrCode', component: () => import('@/views/qrCode/index.vue'), name: '下载二维码' },
            // { path: '/data/yimaiCrmCard', component: () => import('@/views/yimaiCrmCard/index.vue'), name: '红木名片智能CRM' }
        ]
    },
    // {
    //     path: '/',
    //     component: Home,
    //     name: '',
    //     iconCls: 'fa fa-bar-chart',
    //     leaf: true,//只有一个节点
    //     children: [
    //         { path: '/data/yimaiSmartCard', component: () => import('@/views/yimaiSmartCard/index.vue'), name: '账号权限' },
    //         { path: '/data/accountEdit', component: () => import('@/views/yimaiSmartCard/accountEdit.vue'), name: '新增子账号', hidden: true },
    //         // { path: '/data/yimaiCrmCard', component: () => import('@/views/yimaiCrmCard/index.vue'), name: '红木名片智能CRM' }
    //     ]
    // },
    // {
    //     path: '/',
    //     component: Home,
    //     name: '系统管理',
    //     iconCls: 'fa fa-cog',
    //     children: [
    //         { path: '/permissionsManage', component: () => import('@/views/permissionsManage/index.vue'), name: '员工权限' },
    //         { path: '/operationRecords', component: () => import('@/views/operationRecords/index.vue'), name: '操作记录' },
    //     ],
    //     redirect: { path: '/index' }
    // },
    
    {
        path: '*',
        hidden: true,
        redirect: { path: '/404' }
    }
]

export  default routes

// export const constantRouterMap = [
//     {
//         path: '/', 
//         redirect: '/login'
//     },
//     {
//         path: '/login',
//         component: () => import('@/views/Login.vue'),
//         name: '',
//         hidden: true
//     },
//     {
//         path: '/404',
//         component: () => import('@/views/404.vue'),
//         name: '',
//         hidden: true
//     },
// ]

// export const asyncRouterMap = [

// ]


// WEBPACK FOOTER //
// ./src/routes.js